import { render, staticRenderFns } from "./PredictionDetails.vue?vue&type=template&id=4e09c5c2&scoped=true"
import script from "./PredictionDetails.vue?vue&type=script&lang=js"
export * from "./PredictionDetails.vue?vue&type=script&lang=js"
import style0 from "./PredictionDetails.vue?vue&type=style&index=0&id=4e09c5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09c5c2",
  null
  
)

export default component.exports